import React from 'react';

const ButtonComponent = React.memo(
  React.forwardRef(
    (
      {
        onClick,
        disabled = false,
        className = '',
        title = '',
        children,
        loading = false,
      },
      ref
    ) => {
      return (
        <button
          ref={ref}
          onClick={onClick}
          disabled={disabled || loading} // Disable the button when loading
          className={`${loading || disabled ? 'cursor-not-allowed ' : 'cursor-pointer hover:bg-[#191A1D]'} min-w-32 h-10 md:h-12 bg-[#252729] text-white px-6 py-2 rounded-md  transition focus:outline-none font-sans font-semibold ${className}`}
        >
          {/* Show a spinner when loading */}
          {loading ? (
            <div className="spinner-border animate-spin border-t-2 border-white w-5 h-5 rounded-full mx-auto" />
          ) : (
            <>
              {title}
              {children}
            </>
          )}
        </button>
      );
    }
  )
);

export default ButtonComponent;
